import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Grid, Card, CardActionArea, CardMedia, CardContent, Typography, Chip, Box } from '@mui/material';
import { motion } from 'framer-motion';
import { roadmaps } from './data';
import './learn.css';

const MotionCard = motion(Card);

const LearnHome = () => {
  // Simple tab-like filtering for quick access
  const tabIds = ['devops', 'dsa', 'machine-learning', 'gen-ai', 'power-bi'];
  const [activeTab, setActiveTab] = useState('all');
  const filtered = useMemo(() => {
    if (activeTab === 'all') return roadmaps;
    return roadmaps.filter(r => r.id === activeTab);
  }, [activeTab]);

  return (
    <Container maxWidth="lg" className="learn-container">
      <Box sx={{ textAlign: 'center', mt: 4, mb: 2 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Level Up Your Skills
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Curated, flexible roadmaps across major IT domains. Click a card to dive in.
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Chip
            label="All"
            clickable
            color={activeTab === 'all' ? 'primary' : 'default'}
            onClick={() => setActiveTab('all')}
            sx={{ mr: 1 }}
          />
          {tabIds.map(id => (
            <Chip
              key={id}
              label={roadmaps.find(r => r.id === id)?.title || id}
              clickable
              color={activeTab === id ? 'primary' : 'default'}
              onClick={() => setActiveTab(id)}
              sx={{ mr: 1 }}
            />
          ))}
        </Box>
      </Box>

      <Grid container spacing={3}>
        {filtered.map((rm) => (
          <Grid key={rm.id} item xs={12} sm={6} md={4}>
            <MotionCard
              whileHover={{ y: -6 }}
              transition={{ type: 'spring', stiffness: 280, damping: 18 }}
              className="learn-card"
            >
              <CardActionArea component={Link} to={`/learn/${rm.id}`}>
                <CardMedia
                  component="img"
                  height="160"
                  image={rm.image}
                  alt={rm.title}
                  onError={(e) => {
                    const title = encodeURIComponent(rm.title);
                    e.currentTarget.src = `https://via.placeholder.com/1200x620.png?text=${title}`;
                  }}
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    {rm.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {rm.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </MotionCard>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default LearnHome;
